import React from 'react';
import head from 'lodash.head';
import isNil from 'lodash.isnil';
import { getUrlParams } from './urlUtils';
import getVocaboTabs from '../../features/probeDetails/shared/vocabo/vocaboTabs';
import { MEASURE } from '../../constants/shared/MeasuresConstants';
import { PARAM } from '../../constants/shared/ApiConstants';

const { TRC } = MEASURE;
const { GENERATING_RESULT_BY_SCRIPT, GENERATING_RESULT_BY_ASSESSMENT_IMPORTER } = PARAM;

export const processQuestionText = (text, replacement) => text.replace('{{response}}', replacement);

export const getVocaboProbeDetailsData = ({ result: { subResults }, location }) => {
    const availableMeasures = subResults.map(({ measure }) => measure);
    const tabs = getVocaboTabs(availableMeasures, location);
    const selectedMeasure = getUrlParams(location).tab || head(tabs).id;
    const subResult = subResults.find(vocaboResult => vocaboResult.measure === selectedMeasure);

    return {
        tabs,
        subResult,
        selectedMeasure,
    };
};

export const getAssessorId = ({ assessor, measure, itemLevelDetails, resultProbeUid }) => {
    if (measure === TRC) {
        if (isNil(itemLevelDetails)) return null;
        const bookResult = itemLevelDetails.find(
            ({ trcScore }) => resultProbeUid === trcScore.resultSid,
        );
        return bookResult.probeDetailResult.assessorUid;
    }

    return assessor;
};

export const getWordClassName = (isSelfCorrected, isIncorrect, isHidden, isNotInScore) => {
    if (isNotInScore && (isSelfCorrected || isIncorrect)) {
        return 'gray';
    }
    if (isSelfCorrected) {
        return 'green';
    }
    if (isIncorrect) {
        return 'red';
    }
    if (isHidden) {
        return 'hidden-row';
    }
    return '';
};

export const getBracket = showBracket =>
    showBracket && (
        <>
            <span className="bracket" />{' '}
        </>
    );

export const isRowSkipped = (index, skippedRows) => skippedRows && skippedRows.includes(index);

export const getSkippedRowClassName = isSkipped => (isSkipped ? 'strikethru' : '');

export const notIncludedInScore = (itemIndex, lastSelectedIndex) => itemIndex > lastSelectedIndex;

export const getWordIndex = (lineIndex, wordIndex, count) => lineIndex * count + wordIndex;

export const reformatItemLevelDetails = itemLevelDetails => {
    const {
        skipped_rows: skippedRows,
        self_corrected_items: selfCorrectedItems,
        incorrect_items: incorrectItems,
        attempted_syllables: attemptedSyllables,
        attempted_sounds: attemptedSounds,
        last_selected_item: lastSelectedItem,
    } = itemLevelDetails;
    return {
        skippedRows,
        selfCorrectedItems,
        incorrectItems,
        attemptedSyllables,
        attemptedSounds,
        lastSelectedItem,
    };
};

export const isDefaultTypeResult = dataSource =>
    ![GENERATING_RESULT_BY_SCRIPT, GENERATING_RESULT_BY_ASSESSMENT_IMPORTER].includes(dataSource);

/**
 * Index words and rows in paragraphs
 */
export const reformatParagraphs = paragraphs => {
    let currentLineIndex = -1;
    let currentWordIndex = -1;
    return paragraphs.map(paragraph =>
        paragraph.map(row => {
            currentLineIndex += 1;
            return {
                index: currentLineIndex,
                row: row.map(word => {
                    currentWordIndex += 1;
                    return { index: currentWordIndex, word };
                }),
            };
        }),
    );
};
